import { useAuthedTenantMutation } from "../../lib/auth.js";
const SIGNOUT_MUTATION = `
	mutation {
		signOut {
			ok
			error {
				code
				endUserMessage
			}
		}
	}
`;
const useSignOut = () => {
  return useAuthedTenantMutation(SIGNOUT_MUTATION);
};
export {
  useSignOut
};
//# sourceMappingURL=signOut.js.map
